const statusAskTransaction = {
  PENDING: 1,
  PAID: 2,
  REJECT: 3,
};
 
const getStatusAskTransactionString = () => {
  let data = {};
  data[statusAskTransaction.PENDING] = "در حال بررسی درخواست";
  data[statusAskTransaction.PAID] = "پرداخت شده";
  data[statusAskTransaction.REJECT] = "رد شده"
 
  return data;
};


export default {
  statusAskTransaction,
  getStatusAskTransactionString,
};
